<template>
  <BjDrawerForm ref="BjDrawerForm" :form="form" :rules="rules" label-width="120px" @handleConfirm="handleConfirm">
    <el-col :span="colSpan">
      <el-form-item :label="$t('billingPage.CustomerName')" prop="cusId">
        <BjSelectLov v-model="form.cusId" :option-list="customerList" :disabled="isEdit" :placeholder="$t('customerNameText')" />
      </el-form-item>
    </el-col>
    <el-col :span="colSpan">
      <el-form-item :label="$t('billingPage.PalletQty')" prop="palletQty">
        <BjInputNumber v-model="form.palletQty" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
      </el-form-item>
    </el-col>
    <el-col :span="colSpan*2">
      <el-form-item :label="$t('billingPage.startDate')" prop="startTime">
        <el-date-picker
          v-model="form.startTime"
          type="datetime"
          format="dd/MM/yyyy HH:mm"
          :placeholder="$t('billingPage.startDate')"
          :picker-options="pickerOptions"
          >
        </el-date-picker>
      </el-form-item>
    </el-col>
  </BjDrawerForm>
</template>
<script>
import { purchaseApi } from '@/api';
import moment from 'moment';

export default {
  data() {
    return {
      colSpan: 24,
      // 表单参数
      isEdit: false,
      form: {
        cusId: this.$store.getters.cusId || null,
        palletQty: null,
        startTime: null,
      },
      pickerOptions: {
        // 限制时间选择今天及以后的
        disabledDate(time) {
          return time.getTime() > new Date().getTime();
        },
      },
    };
  },
  computed: {
    rules() {
      // 表单校验
      const rules = {
        cusId: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        palletQty: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        startTime: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
      };
      return rules;
    },
    customerList() {
      return this.$store.getters.customerList;
    },
  },
  mounted() {
  },
  methods: {
    show(info) {
      this.isEdit = !!info;
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(this.isEdit ? this.$t('editText') : this.$t('addText'));
      this.form = Object.assign(info || {});
    },

    handleConfirm() {
      let API_DATA = this.$lodash.clone(this.form);
      API_DATA = {
        ...API_DATA,
        startTime: moment(API_DATA.startTime).format('YYYY-MM-DD HH:mm:ss'),
        status:'0',
        operater:this.$store.getters.userInfo.loginName
      }
     
      if (this.isEdit) {
        this.updateApi(API_DATA);
      } else {
        this.addApi(API_DATA);
      }
    },
    reFresh() {
      this.$emit('reFresh');
    },
    addApi(API_DATA) {
      purchaseApi.addPurchaseTemporaryList(API_DATA).then(res => {
        if (!res.failed) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
    updateApi(API_DATA) {
      purchaseApi.modifyPurchaseTemporaryList(API_DATA).then(res => {
        if (!res.failed) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
